import Head from 'next/head';
import styled from 'styled-components';
import {GetServerSideProps} from 'next';
import {useTranslation} from 'next-i18next';
import {QueryClient} from '@tanstack/react-query';
import LandingUseCasesSection from 'src/components/landing/LandingUseCasesSection';
import {WidthContainer} from 'src/components/landing/LandingComponents';
import VideoDemoContent from 'src/components/landing/VideoDemoContent';
import DemoHeroSection from 'src/components/demo/DemoHeroSection';
import LandingHeader from 'src/components/landing/LandingHeader';
import LandingFooter from 'src/components/landing/LandingFooter';
import {getPublicLayout} from 'src/components/PublicLayout';
import {nsTranslation, nsWebsite} from 'src/services/i18n';
import RowOfLogos from 'src/pages/landing-page/RowOfLogos';
import ssrTranslations from 'src/utils/ssrTranslations';
import getTitle from 'src/utils/getTitle';

const StyledWidthContainer = styled(WidthContainer)`
  display: flex;
  flex-direction: column;
  margin-top: 100px;
  padding-bottom: 40px;
  align-items: center;

  @media (max-width: 900px) {
    padding: 0 var(--side-padding) 20px var(--side-padding);
    margin-top: 80px;
  }
`;

const CompaniesDescription = styled.p`
  font-size: 16px;
  text-align: center;
`;

const VideoDemo = () => {
  const {t} = useTranslation();

  return (
    <>
      <Head>
        <title>{getTitle(t('website.see demo video'))}</title>
      </Head>

      <LandingHeader />

      <VideoDemoContent />

      <StyledWidthContainer>
        <DemoHeroSection />

        <CompaniesDescription>{t('website.company logos description')}</CompaniesDescription>
        <RowOfLogos />
      </StyledWidthContainer>

      <LandingUseCasesSection />

      <LandingFooter />
    </>
  );
};

VideoDemo.isPublicPage = true;

VideoDemo.getLayout = getPublicLayout;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const queryClient = new QueryClient();

  return {props: {...(await ssrTranslations(context, queryClient, [nsTranslation, nsWebsite]))}};
};

export default VideoDemo;
